import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';
import Modal from '@roo/roo/Modal';
import * as Ids from '@utils/ids';
import request from '@utils/axiosWrapper';
import { FRAME_NAME, sendMessageToSubFrame } from '@projects/Shell/utils/subFrames';
import * as LX from '@utils/lxWrapper';

const POLLING_INTERVAL = 5 * 60 * 1000;
/** 异常天气延长配送通知 */

const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            request
                .get<{ showWindow: boolean; title: string; content: string }>(
                    '/gw/api/logistics/dispatchAddTime',
                    { params: { wmPoiId: Ids.getWmPoiId() } },
                )
                .then(res => {
                    if (res.showWindow && res.title && res.title.length > 0) {
                        LX.reportPV('c_waimai_e_9gosv5mu');
                        Modal.confirm({
                            title: res?.title,
                            children: res?.content,
                            confirmText: '我知道了',
                            cancelText: '撤销加时',
                            onCancel: () => {
                                LX.reportMC('b_waimai_e_khjl50t6_mc', 'c_waimai_e_9gosv5mu');
                                request
                                    .postAsFormSubmit(
                                        '/gw/api/poi/dispatch/duration/cancelDispatchAddTime',
                                        {
                                            wmPoiId: Ids.getWmPoiId(),
                                        },
                                    )
                                    .then(() => {
                                        sendMessageToSubFrame(FRAME_NAME.HASH, {
                                            type: 'cancelDispatchAddTime',
                                        });
                                    });
                            },
                            onConfirm: () => {
                                LX.reportMC('b_waimai_e_fomnuln4_mc', 'c_waimai_e_9gosv5mu');
                            },
                        });
                    }
                });
        });
};

export default { init };
